import React from 'react';
import styles from './ProfileCard.module.scss';
import { Box } from 'new/elements/Box';
import { ProfileImage, ProfileImageProps } from 'new/elements/ProfileImage';
import { Typography } from '@mui/material';

export type ProfileCardProps = {
  name?: string;
  badge?: string;
};

export function ProfileCard(props: ProfileCardProps & Omit<ProfileImageProps, 'fullName'>) {
  return (
    <Box onClick={props.onClick} className={styles.box}>
      <div className={styles.container}>
        <ProfileImage fullName={props.name} source={props.source} />
        <Typography component="h5" className={styles.name}>
          {props.name}
        </Typography>
        {!!props.badge ? (
          <div className={styles.badgeContainer}>
            <Typography className={styles.badge}>{props.badge}</Typography>
          </div>
        ) : null}
      </div>
    </Box>
  );
}
